export default __webpack_public_path__ + "static/media/image.pink-drives.5b33a9c1.png";